import { render, staticRenderFns } from "./TheNuevoClasificacionCie.vue?vue&type=template&id=0c321eac&"
import script from "./TheNuevoClasificacionCie.vue?vue&type=script&lang=js&"
export * from "./TheNuevoClasificacionCie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports